import * as React from "react";
import {Col, Row} from "react-bootstrap";
import {Documento} from "../modelo/Documento";
import {obtenerTipoIdentificacion} from "../modelo/TiposIdentificacion";
import ModalDocumentos from "./ModalDocumentos";

export default class InformacionBasicaDocumento extends React.Component<InformacionBasicaDocumentoProps> {

    render() {
        const {documento,canalComercial} = this.props;
        return (
            <div className={"card"}>
                <div className={"card-header"}>
                    <h3 className={"panel-title"}>Información Básica</h3>
                </div>
                <div className={"card-body"}>
                    <Row className="form-group">
                        <Col sm={2}>
                            <label className={"ltitle"}>Tipo Documento:</label>
                        </Col>
                        <Col sm={4} className={"text-left"}>
                            <label className={"label-text"}>
                                {obtenerTipoIdentificacion(documento.afiliado.identificacion.charAt(0)).name}
                            </label>
                        </Col>
                        <Col sm={2}>
                            <label className={"ltitle"}>No. Documento:</label>
                        </Col>
                        <Col sm={4}>
                            <label className={"label-text"}>{documento.afiliado.identificacion.substring(1)}</label>
                        </Col>
                    </Row>
                    <Row className="form-group">
                        <Col sm={2}>
                            <label className={"ltitle"}>Nombre Legal:</label>
                        </Col>
                        <Col sm={4}>
                            <label className={"label-text"}>{documento.afiliado.nombreLegal}</label>
                        </Col>
                        <Col sm={2}>
                            <label className={"ltitle"}>Nombre Comercial:</label>
                        </Col>
                        <Col sm={4}>
                            <label className={"label-text"}>{documento.afiliado.nombreComercial}</label>
                        </Col>
                    </Row>
                    <Row className="form-group">
                        <Col sm={2}>
                            <label className={"ltitle"}>Tipo Cliente:</label>
                        </Col>
                        <Col sm={4}>
                            <label className={"label-text"}>{documento.tipoCliente.nombre}</label>
                        </Col>
                        <Col sm={2}>
                            <label>Ver Documentos</label> <br/>
                        </Col>
                        <Col sm={4}>
                            <ModalDocumentos dni={documento.afiliado.identificacion}
                                             documentosP8={documento.documentos}
                                             tipoCliente={documento.tipoCliente}
                                             nombreLegal={documento.afiliado.nombreLegal}
                                             canalComercial={canalComercial}
                                             poliza={documento.poliza}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }

}

interface InformacionBasicaDocumentoProps {
    documento: Documento,
    canalComercial?: boolean
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/componentes/InformacionBasicaDocumento.tsx